export class TimeEntryCategory {
  id: string;
  externalId: string;  
  name: string;
  enabled: boolean;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.externalId = payload.externalId;
      this.name = payload.name;
      this.enabled = payload.enabled;
    }
  }

  /**
   * creates users from a result
   * @param result Array of any
   * @returns Array of User
   */
  static createTimeCategoryEntries(result: Array<any>): TimeEntryCategory[] {
    const timeCategoryEntries = new Array<TimeEntryCategory>();
    if (result) {
      result.map((timeCategoryEntry) => {
        timeCategoryEntries.push(new TimeEntryCategory(timeCategoryEntry));
      });
    }
    return timeCategoryEntries;
  }

}

export class TimeEntryCategoryInput {
  id: string;
  name: string;
  externalId: string;
  enabled: boolean; 

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.name = payload.name;
      this.externalId = payload.externalId;
      this.enabled = payload.enabled;
    }
  }

}
